export default {
    'Loading...': 'Yuklanmoqda...',
    'Booking an appointment': 'Qabulga yozilish',
    'Online registration is disabled': 'Online-qabul faol emas',
    'Select service': 'Xizmatni tanlang',
    'Confirm': 'Tasdiqlash',
    'Enter the phone number provided by registering at the clinic': 'Klinikada r\'oyxatdan o\'tgan telefon raqamingizni kiriting',
    'Enter Phone Number': 'Telefon raqamini kiriting',
    'Send': 'Yuborish',
    'Verification Code': 'Tasdiqlash kodi',
    'verification-message': '{phone} raqamiga tasdiqlash kodi yuborildi. Tasdiqlash kodni kiriting.',
    'Invalid code': 'Noto\'g\'ri kod',
    'Wrong Number?': 'Noto\'g\'ri raqam?',
    'Verifying...': 'Tasdiqlanmoqda...',
    'Verify': 'Tasdiqlash',
    'Name': 'Ism',
    'Enter Name': 'Ismingizni kiriting',
    'Surname': 'Familiya',
    'Enter Surname': 'Familiyangizni kiriting',
    'Saving...': 'Saqlanmoqda...',
    'Save': 'Saqlash',
    'We will contact you shortly and confirm the appointment.': 'Siz bilan tez orada aloqa chiqamiz va so\'rovingizni tasdiqlaymiz.',
    'No free time available': 'Bu kun bo\'sh vaqt mavjud emas',
    'Back to Home': 'Boshiga qaytish',
    'No upcoming appointments': 'Bo\'lajak qabullar mavjud emas',
    'Select clinic': 'Klinikani tanlang',
    'You are registered in these clinics': 'Siz quydagi klinikalarda ro\'yxatdan o\'tgansiz',
    'No clinics': 'Klinikalar topilmadi',
    'Home': 'Asosiy',
    'Appointments': 'Qabullar',
    'Contacts': 'Kontaktlar',
    'Switch clinic': 'Boshqa klinikaga o\'tish',
    'Logout': 'Chiqish',
    'Log in to your personal cabinet': 'Shaxsiy kabinetga kirish',
    'Log In': 'Kirish',
    'Book an appointment': 'Qabulga yozilish',
    'Upcoming appointments': 'Kelgusi qabullar',
    'Show all': 'Hammasini ko\'rish',
    'Not confirmed': 'Tasdiqlanmagan',
    'Confirmed': 'Tasdiqlangan',
    'Cancelled': 'Bekor qilingan',
    'Completed': 'Yakunlangan',
    'Not shown': 'Kelmadi',
    'Started': 'Boshlandi',

    'Please, enter valid phone number': 'Iltimos, telefon raqamini to\'g\'ri kiriting',
    'Enter code from SMS': 'SMSdagi kodni kiriting',

    'Select a specialist': 'Mutaxassis tanlang',
    'No specialists available': 'Mutaxassis topilmadi',
    'Select a day': 'Kunni tanlang',
    'Select a time': 'Vaqtni tanlang',
    'Input data to register': 'Ro\'yxatdan o\'tish uchun ma\'lumotlarni kiriting',
    'Enter your name': 'Ismingizni kiriting',
    'Enter your phone number': 'Telefon raqamigizni kiriting',
    'Phone number': 'Telefon raqami',

    'Clinic not found': 'Klinika topilmadi',
    'Check the link or contact the clinic': "Havolani tekshiring yoki klinikaga murojaat qiling",
    'Please call the clinic to book an appointment': "Qabulga yozilish uchun klinikaga qo'ng'iroq qiling",
    'About the clinic': 'Klinika haqida',
    'Open now': 'Ochiq',
    'Closed now': 'Yopiq',
    'Closed': 'Yopiq',
    'Change': "O'zgartirish",
    'Back': 'Orqaga',
    'Step {current} of {total}': '{total} dan {current}-qadam',
    'Select date and time': 'Kun va vaqtni tanlang',
    'Your phone number': 'Telefon raqamingiz',
    'Check the details': "Ma'lumotlarni tekshiring",
    'Appointment booked': 'Siz qabulga yozildingiz',
    'No services available': 'Xizmatlar mavjud emas',
    'Try another service or call the clinic': "Boshqa xizmatni tanlang yoki klinikaga qo'ng'iroq qiling",
    'Week': 'Hafta',
    'Month': 'Oy',
    'Pick another day in the calendar above': 'Yuqoridagi kalendardan boshqa kunni tanlang',
    'Morning': 'Ertalab',
    'Afternoon': 'Kunduzi',
    'Evening': 'Kechqurun',
    'We will send a confirmation code to this number': 'Ushbu raqamga tasdiqlash kodi yuboriladi',
    'Your details are used only for this appointment': "Ma'lumotlaringiz faqat shu qabul uchun ishlatiladi",
    'Verification failed, try again!': "Kodni tasdiqlab bo'lmadi, qayta urinib ko'ring",
    'Resend code': 'Kodni qayta yuborish',
    'Resend in {seconds} s': '{seconds} s dan keyin qayta yuborish',
    'Specialist': 'Mutaxassis',
    'Service': 'Xizmat',
    'Address': 'Manzil',
    'Clinic phone': 'Klinika telefoni',
    'Could not book the appointment, please try again': "Qabulga yozib bo'lmadi, qayta urinib ko'ring",
    'We will contact you shortly to confirm the appointment': "Tez orada siz bilan bog'lanamiz va qabulni tasdiqlaymiz",
    'Website': 'Sayt',
    'Email': 'Pochta',
    'Opening hours': 'Ish vaqti',
    'Today': 'Bugun',
    'Tomorrow': 'Ertaga',
    'Nearest available time': "Eng yaqin bo'sh vaqt",
    'All specialists': 'Barcha mutaxassislar',
    'No free time in the next days': "Yaqin kunlarda bo'sh vaqt yo'q",
    'Search by name': "Ism bo'yicha qidirish",
    'Nobody found': 'Hech kim topilmadi',
    'Choose another service': 'Boshqa xizmatni tanlash',
    'Could not load the time': "Vaqtni yuklab bo'lmadi",
    'Check the connection and try again': "Aloqani tekshiring va qayta urinib ko'ring",
    'Try again': 'Qayta urinish',
    'Thank you for the reservation': 'Bron uchun rahmat',
    'Go to your cabinet': "Kabinetga o'tish",
}
